import { useEffect, useMemo, useState } from 'react';
import {
	formatToCurrency,
	formatToPercentage,
	formatToDecimal,
} from '../../../util/formatting';
import type { PromotionDto } from '../types/PromotionDto';

export function useFormatDiscount(promotion: PromotionDto) {
	const discount = useMemo(() => {
		if (promotion.priceType.includes('£')) {
			return formatToCurrency(promotion.discount);
		}

		if (promotion.priceType.includes('%')) {
			return formatToPercentage(promotion.discount);
		}

		return formatToDecimal(promotion.discount);
	}, [promotion]);

	return discount;
}
